var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.toExoSystemHc ? _vm._t("haichuang") : _vm._e(),
      !_vm.toExoSystemHc
        ? [
            _vm._t("DoorToDoorLoading"),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "row" } },
              _vm._l(_vm.upElementBlocks, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "section",
                    staticStyle: { "margin-right": "10px" }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.title))
                    ]),
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          "padding-left": "15px",
                          "padding-right": "10px"
                        },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "0" } },
                          [
                            item.elementNames.includes("multiplePickups")
                              ? _vm._t("multiplePickups")
                              : _vm._e(),
                            item.elementNames.includes("multipleCabinets")
                              ? _vm._t("multipleCabinets")
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._l(item.elementNames, function(elementName) {
                          return [
                            elementName !== "multiplePickups" &&
                            elementName !== "multipleCabinets"
                              ? _vm._t(elementName)
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]
        : _vm._e(),
      !!_vm.downElementBlock
        ? _c(
            "div",
            { staticClass: "section" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.downElementBlock.title))
              ]),
              _vm._l(_vm.downElementBlock.elementNames, function(elementName) {
                return _vm._t(elementName)
              })
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }